import {SPONSOR_FILE_LIST} from 'ActionsSponsorsFile';

export function sponsorFileList(state = [], acition) {
  if (acition.type === SPONSOR_FILE_LIST) {
    return acition.payload;
  }
  return state;
}
